import { Inject, Pipe, PipeTransform } from '@angular/core';
import { JSR310ConversionService } from '../../../shared/jsr310-localdates/services/jsr310-conversion.service';
import { LocalDate } from '../../../shared/jsr310-localdates/types/local-date.type';

@Pipe({
	name: 'displayNbJoursAvantExpiration'
})
export class DisplayNbJoursAvantExpirationPipe implements PipeTransform {
	
	nowInMillis: number = new Date().getTime();
	
	constructor(
		@Inject(JSR310ConversionService) private conversionService: JSR310ConversionService
	) {}
	
	transform(finValidite: number[] | null | undefined): string | undefined {
		if (!finValidite) {
			return undefined;
		}
		
		let localDateFinValidite = [finValidite[0], finValidite[1], finValidite[2]] as LocalDate;
		let dateFin = this.conversionService.fromLocalDate(localDateFinValidite);
		if (dateFin) {
			let nbJours = Math.ceil((dateFin.getTime() - this.nowInMillis) / (1000 * 3600 * 24));
			if (nbJours > 0) {
				return nbJours.toString();	
			}
		}
		return '-';
	}
	
}